module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_c('b', [_vm._v("1. The Early Times")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h1"
    }
  }, [_vm._v("Our Native Americans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h2"
    }
  }, [_vm._v("The Early Settlers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h3"
    }
  }, [_vm._v("Recollections from the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h4"
    }
  }, [_vm._v("Life on the Old Ranchos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h5"
    }
  }, [_vm._v("Ballona Creek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h6"
    }
  }, [_vm._v("Saenz Store")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h7"
    }
  }, [_vm._v("Statehood and Camp Latham")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h8"
    }
  }, [_vm._v("First School and Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h9"
    }
  }, [_vm._v("Baldwin Hills")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h10"
    }
  }, [_vm._v("Ivy Substation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2. Culver City Takes Shape")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enter Harry Culver")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harry Culver’s Dream: The 1913 Speech")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Fork in the Road: Palms and Culver City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pacific Military Academy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culver’s Lasting Influence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culver City Government")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("City Halls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culver City Police Department")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culver City Fire Department")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culver City Bus Department")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("City Streets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Annexations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post Offices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3. The Business of Building and Development")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culver Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adams Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Citizen Building")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hull Building")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washington Building")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legion Building")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helms Bakeries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shopping")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Downtown Culver City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culver Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hayden Tract")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4. The Movie Studios")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Major Studio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Studio Tours: Recollections of a Tour Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More on the Backlots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ince’s Second Studio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hal Roach Studios")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smaller Studios")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Heart of Screenland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Oscars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5. Education")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elementary Schools")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culver City Unified School District: Secondary Schools")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6. Entertainment, Cultural Resources and More Lasting Memories")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nightclubs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theaters in Culver City, the Heart of Screenland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Racetracks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culver City Airport: The Early Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joe Petrelli’s Airport Cafe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stern’s Famous Barbecue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rollerdrome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Egyptian House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piccadilly’s and Drag Racing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fiesta La Ballona")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rose Parade Floats")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Resources: Organizations, Service Clubs and Sister Cities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Libraries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gone but Not Forgotten: The Culver City Redevlopment Agency")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historic Sites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 63
// module chunks = 0